module.exports = __webpack_public_path__ + "img/branch-icon.6ea34ce2.svg";